import styled, { css } from 'styled-components';
import { Atom } from 'AppReact';

const template = styled.div`
  ${({ theme, displayState }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    cursor: pointer;

    color: ${theme?.colour?.secondary ?? '#04333B'};
    ${displayState.selected && css`
      color: ${theme?.colour?.primary ?? '#1DBD6B'};
    `}

    &:hover {
      background: ${`${theme?.colour?.primary}0D`};
    }
  `}
`;

export default Atom({ type: 'button', dataType: '', template });
